export default __webpack_public_path__ + "static/media/info-bg.2cc63ab0.jpg";